import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  register,
  clearError,
  selectIstAngemeldet,
  selectAuthStatus,
  selectAuthError,
} from 'core/features/auth/authSlice';
import PageBackground from 'core/components/PageBackground';
import AuthCard from 'core/components/AuthCard';

/** Registrierungsseite (Benutzername, E-Mail, Passwort). */
export default function RegisterPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const istAngemeldet = useSelector(selectIstAngemeldet);
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (istAngemeldet) {
      navigate('/', { replace: true });
    }
  }, [istAngemeldet, navigate]);

  useEffect(() => () => dispatch(clearError()), [dispatch]);

  const absenden = (e) => {
    e.preventDefault();
    dispatch(register({ username: username.trim(), email: email.trim(), password }));
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <PageBackground name="overview" />
      <AuthCard titel="Registrieren" untertitel="Lege ein Konto an – Depot und Listen sind dann nur deine.">
        <form onSubmit={absenden} className="flex flex-col gap-4">
          <AuthCard.Feld
            label="Benutzername"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
          <AuthCard.Feld
            label="E-Mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <AuthCard.Feld
            label="Passwort (min. 6 Zeichen)"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={6}
            autoComplete="new-password"
          />
          {error && <AuthCard.Fehler text={error} />}
          <AuthCard.Button laeuft={status === 'loading'}>Konto erstellen</AuthCard.Button>
        </form>
        <p className="mt-6 text-center text-sm text-ink-muted">
          Schon ein Konto?{' '}
          <Link to="/login" className="font-medium text-ink underline hover:no-underline">
            Anmelden
          </Link>
        </p>
      </AuthCard>
    </div>
  );
}
